import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faB, faCheckCircle, faPaperPlane, faCircle, faClose, faTrash, faS, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
library.add(faB, faS, faTrash, faCheckCircle, faCircle, faClose, faPlusCircle,faPaperPlane,)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
